import { useState } from 'react';

import {
  S9ComponentConfig,
  S9ComponentConfigCategory,
  S9ComponentConfigRelease,
} from '@april9au/stack9-sdk';
import * as ui from '@april9au/stack9-ui';

import { AppRoutes } from '../../constants/appRoutes';
import { entityNames } from '../../constants/entities';
import { EDetailsQueryNames } from '../../constants/queryNames';
import { DBIndustry } from '../../models/stack9/Industry';
import { EntityDrawer } from '../EntityDrawer/EntityDrawer';
import { IndustryDrawer } from '../IndustryDrawer/IndustryDrawer';

const S9Button = ui.S9Button.default;
const { useRefreshList, Space } = ui;

export const config: S9ComponentConfig = {
  name: 'IndustryDrawerAction',
  icon: '',
  category: S9ComponentConfigCategory.GENERAL,
  version: S9ComponentConfigRelease.ALPHA,
  hasState: true,
  allowChildren: false,
  props: [],
};

type IndustryDrawerActionProps = {
  row: Partial<DBIndustry>;
};

const IndustryDrawerAction = ({ row }: IndustryDrawerActionProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const refresh = useRefreshList();

  const formFields = [
    { field: 'code' },
    { field: 'name' },
    { field: 'is_active' },
    { field: 'lang_set' },
  ];
  return (
    <>
      {row.id ? (
        <>
          <S9Button
            type="link"
            style={{ width: '100%', textAlign: 'left' }}
            onClick={() => setIsOpen(true)}
            label={`${row.code}`}
          />
          <IndustryDrawer
            initialValues={row}
            id={row.id}
            open={isOpen}
            onClose={() => {
              setIsOpen(false);
              refresh();
            }}
          />
        </>
      ) : (
        <>
          <Space>
            <S9Button
              label="Create"
              onClick={() => setIsOpen(true)}
              type="primary"
            />
          </Space>
          <EntityDrawer
            title="Industry"
            id={row?.id}
            open={isOpen}
            formFields={formFields}
            initialValues={row}
            onClose={() => {
              setIsOpen(false);
              refresh();
            }}
            screenQueryName={EDetailsQueryNames.GetIndustryDetails}
            entityName={entityNames.INDUSTRY}
            editRoute={AppRoutes.CountrySetupDetail}
            relativePath={AppRoutes.CountrySetupDetail}
          />
        </>
      )}
    </>
  );
};

export default IndustryDrawerAction;
